import $ from 'jquery';
// export for others scripts to use
window.jQuery = $;
window.jquery = $;
window.$ = $;
import whatInput from 'what-input';
import Foundation from 'foundation-sites';
import Swiper from 'swiper';
import lightgallery from 'lightgallery.js';
import LgThumbnail from 'lg-thumbnail.js';
import 'skip-link-focus-fix.js';
import 'cookie-consent.js';

document.addEventListener('DOMContentLoaded', function(event) {
	
  // Foundation
	jQuery(document).foundation();
	
	// Add class on scroll up. Remove on scroll down. Also add another class on scroll amount of pixels
	var lastScrollTop = 0;
	window.onscroll = function changeClass(){
		var st = window.pageYOffset || document.documentElement.scrollTop;
		var mastHead = document.querySelector('#masthead');
		
		//if (st > lastScrollTop){
		//  mastHead.classList.add('hide-header');
		//  
		//} else {
		//  mastHead.classList.remove('hide-header');
		//  
		//}
		
		if(st > 358) {
			mastHead.classList.add('bg-header');
			
		} else if(st <= 358) {
			mastHead.classList.remove('bg-header');
			
		}
		
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	};
	
	
	
	// Menu show/hide
	// Show navigation menu
	let open  = document.querySelector('.menu-open');
	let close = document.querySelector('.menu-close');
	
	let menu  = document.querySelector('.main-navigation');
	let logo  = document.querySelector('.site-title__logo');
	
	//var openClose = [open, logo];
	//var oLen = openClose.length;
	//
	//for (i = 0; i < oLen; i++) {
	//  
	//  oLen[i].addEventListener('click', function(e){
	//		menu.classList.toggle('is-active');
	//		logo.classList.toggle('force-white');
	//		e.preventDefault();
	//	});
	//}
	
	open.addEventListener('click', function(e){
		menu.classList.toggle('is-active');
		logo.classList.toggle('force-white');
		e.preventDefault();
	});
	
	close.addEventListener('click', function(e){
		menu.classList.toggle('is-active');
		logo.classList.toggle('force-white');
		e.preventDefault();
	});
	
	// Swiper slider
	var swiper = new Swiper('.swiper-container', {
		direction: 'vertical',
		loop: true,
		
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    
    on: {
	    transitionStart: function () {
	      //document.getElementsByClassName('swiper-slide__first-half').classList.remove('fadeInUpBig');
	      //document.getElementsByClassName('swiper-slide__second-half').classList.remove('fadeInDownBig');
	    },
	    
	    transitionEnd: function () {
	      //document.getElementsByClassName('swiper-slide__first-half').classList.add('fadeInUpBig');
	      //document.getElementsByClassName('swiper-slide__second-half').classList.add('fadeInDownBig');
	    },
	  }
  });
  
	// Enable Lightbox Gallery
	lightGallery(document.getElementById('lightgallery'), {
		thumbnail:true
	});
	
	lightGallery(document.getElementById('planesLightgallery'), {
		thumbnail:true
	});

});